import { DateUtil, TIME } from '@utils/dateUtil'
import { RangePattern, RecurrenceT, TypePattern } from '../types'

type ParamsT = {
  fromDate: DateUtil
  companyLimitation: DateUtil | null
  recurrence: RecurrenceT
}

export default function getNumberLimit({
  fromDate,
  recurrence,
  companyLimitation,
}: ParamsT): number {
  let count = 1
  const limit = companyLimitation || recurrence.dateLimit

  if (recurrence.typeInterval === 0) return count

  if (recurrence.rangePattern === RangePattern.AFTER) {
    if (recurrence.typePattern === TypePattern.DAILY) {
      let next = fromDate.clone().add(recurrence.typeInterval, TIME.DAYS)

      while (next.isSameOrBefore(limit, TIME.DAYS)) {
        next = next.add(recurrence.typeInterval, TIME.DAYS)
        count += 1
      }
    }

    if (recurrence.typePattern === TypePattern.WEEKLY) {
      if (!recurrence.daysOfWeek.length) return count
      let next = fromDate.clone()

      while (next.isSameOrBefore(limit, TIME.WEEKS)) {
        for (let i = 0; i < 7; i++) {
          const nextDay: DateUtil = next.weekDay(i)
          const day = recurrence.weekdays[i]

          if (recurrence.daysOfWeek.includes(day)) {
            if (nextDay.isSameOrBefore(limit, TIME.DAYS) && fromDate.isBefore(nextDay, TIME.DAYS)) {
              count += 1
            }
          }
        }

        next = next.add(recurrence.typeInterval, TIME.WEEKS)
      }
    }

    if (recurrence.typePattern === TypePattern.MONTHLY) {
      if (recurrence.monthlyType === 'absolute_monthly') {
        let next = fromDate.clone().add(recurrence.typeInterval, TIME.MONTHS)
        while (next.isSameOrBefore(limit, TIME.DAYS)) {
          count += 1
          next = next.add(recurrence.typeInterval, TIME.MONTHS)
        }
      }
    }
  }

  return count
}
